import { render, staticRenderFns } from "./healthcasts.vue?vue&type=template&id=1a1a89c0&scoped=true&v-once=true"
import script from "./healthcasts.vue?vue&type=script&lang=js"
export * from "./healthcasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a89c0",
  null
  
)

export default component.exports